import styled from 'styled-components';

/**
 * These styled components are all pieces used to build generic screen
 * layouts, like the full page container, generic row components, etc.
 */

// Optionally can be used as a darkening overlay
export const FullPage = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 0;
  width: 100%;
  height: 100vh;
  min-height: 0px;
  overflow: hidden;
  background-color: transparent;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 0px;
`;
